import createAction from 'redux-actions/es/createAction';

export const forcePasswordChangeRequest = createAction('FORCE_PASSWORD_CHANGE_REQUEST');
export const forcePasswordChangeSuccess = createAction('FORCE_PASSWORD_CHANGE_SUCCESS');
export const forcePasswordChangeFail = createAction('FORCE_PASSWORD_CHANGE_FAIL');
